<template>
  <div class="split-layout">
    <div class="content-side">
      <div class="content-wrapper">
        <!-- Header Section -->
        <div class="header-section">
          <slot name="header"></slot>
        </div>

        <!-- Main Content Section -->
        <div class="content-section">
          <slot name="content"></slot>
        </div>

        <!-- Actions Section -->
        <div class="actions-section">
          <portal-target name="onboarding-actions"></portal-target>
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
    
    <!-- Right Panel -->
    <div class="dark-side">
      <slot name="right-panel"></slot>
    </div>
  </div>
</template>

<script>
import { PortalTarget } from 'portal-vue'

export default {
  components: {
    PortalTarget
  },
  provide() {
    return {
      portalTarget: 'onboarding-actions'
    }
  }
}
</script>

<style lang="scss" scoped>
.split-layout {
  display: flex;
  min-height: 100vh;
}

.content-side {
  flex: 0 0 55%;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 48px;
}

.header-section {
  flex: 0 0 auto;
  margin-bottom: 32px;
}

.content-section {
  flex: 1;
  overflow-y: auto;
  min-height: 0;  // Important for proper flexbox scrolling
  padding-right: 16px;  // Space for scrollbar
  margin-bottom: 32px;

  // Scrollbar styling
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }
}

.actions-section {
  flex: 0 0 auto;
  padding-top: 16px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
}

.dark-side {
  flex: 0 0 45%;
  background-color: #111111;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
